module.exports = "/assets/data/dc47829e73eba010ec2c867d0e477e4b-LA23.data.json";